export default __webpack_public_path__ + "static/media/sindoh1x.7278abde.png";